var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwapVert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.90231 11.9835V2.47345L0.918554 6.45721L0 5.54609L5.54609 0L11.0921 5.54609L10.1736 6.45721L6.18983 2.47345V11.9835H4.90231ZM12.4539 23.1747L6.90782 17.6286L7.82641 16.7175L11.8102 20.7012V11.1912H13.0977V20.7012L17.0814 16.7175L18 17.6286L12.4539 23.1747Z",
    fill: "#758494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapVert);
export default __webpack_public_path__ + "static/media/swap_vert.c4aeb8b273b93a63e859b31fb062bf79.svg";
export { ForwardRef as ReactComponent };